import React from "react";
import SectorLayout from "@/components/SectorLayout";
import data from "@/data/sectors/elevage";
export default function SecteurElevage() { return <SectorLayout data={data} />; }
